// extracted by mini-css-extract-plugin
export default {"icon-button":"IconButton_icon-button__zx5-P","icon":"IconButton_icon__f54a1"};